import React from 'react';
import { Card, Row, Col, Divider } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router';
import classNames from 'classnames';
import styles from './NextSteps.module.less';
import { trackButtonClick } from '../../../lib/fpti';
import isAbsolutePath from '../../../util/isAbsolutePath';

const NextSteps = ({ ecmContent }) => {
  const { jsonObject } = ecmContent;
  const { title, subtitle, images, cardWidth = 4 } = jsonObject;
  const navigate = useNavigate();
  const { country = '' } = useParams();
  const handleClick = (key, url) => {
    trackButtonClick(key, url);
    if (isAbsolutePath(url)) {
      if (url.includes('/studio')) {
        window.open(url, '_self', 'popup=false');
      } else {
        window.open(url, '_blank');
      }
    } else {
      navigate(url);
    }
  };

  const howToIntegrate = classNames({
    [styles.how_to_integrate]: jsonObject.type === 'how_to_integrate'
  });

  return (
    <div className={howToIntegrate}>
      {title && <div className={`${styles.next_steps_title}`}>{title}</div>}
      {subtitle && <div className={`${styles.next_steps_subtitle}`}>{subtitle}</div>}
      <Row className={`${styles.next_steps_cards}`}>
        {images.map(
          (
            {
              url,
              link_name,
              image_url,
              sub_header,
              top_header,
              sub_text,
              dividing_line,
              links = []
            },
            index
          ) => (
            <Col key={index} xs={12} lg={cardWidth} className={`${styles.next_steps_box}`}>
              <Card onClick={links.length || link_name ? null : () => handleClick(sub_header, url)}>
                {top_header && <div className={`${styles.next_steps_topheader}`}>{top_header}</div>}
                <img src={image_url} alt="" />
                <div className={`${styles.next_steps_subheader}`}>{sub_header}</div>
                <div className={`${styles.next_steps_subtext}`}>{sub_text}</div>
                {dividing_line && <Divider />}
                <div className={styles.links_container}>
                  {link_name && (
                    <a href={url.replace('{country}', country)} className={styles.next_steps_link}>
                      {link_name}
                    </a>
                  )}
                  {links.map(({ url, label }, index) => (
                    <a key={index} href={url} className={styles.next_steps_link}>
                      {label}
                    </a>
                  ))}
                </div>
              </Card>
            </Col>
          )
        )}
      </Row>
    </div>
  );
};

NextSteps.propTypes = {
  ecmContent: PropTypes.object.isRequired
};

export default NextSteps;
